import { hot } from "react-hot-loader"
import React, { Component } from "react";

var snakeCaseKeys = require('snakecase-keys')

const {
    RadioControl,
    TextControl,
    PanelBody,
  } = wp.components;
  const {
    InspectorControls,
  } = wp.editor;
  

function EditBlock( { attributes, setAttributes } ) {
    const { defaultURL, tempURL, url, widthField, borderField, scrollField, classField, 
            lcode, dcode, lang, sessionSeed, onlyRooms, eurota, currency, 
            bookRooms, pid, occupancies, filters, relink } = attributes;
    
    const {background, addressBackground, addressText, topBar, topBarText, 
      buttonBackground, buttonText, amenity, promoBackground, promoText, 
      continueButtonBackground, continueButtonText, roomsText, virtualsText, 
      pricesText, offersText, calendarEndpointBackground, calendarBetweenBackground} = attributes.customColors;


    const customColors = attributes.customColors;

    function onChangeURLField( newValue ) {
      if(newValue === '')
        setAttributes( { tempURL: defaultURL } );
      else
        setAttributes( { tempURL: '' } );
      setAttributes( { url: newValue } );
    }

    function onChangeWidthField( newValue ) {
      setAttributes( { widthField: newValue } );
    }

    function onChangeBorderField( newValue ) {
      setAttributes( { borderField: newValue } );
    }

    function onChangeScrollField( newValue ) {
      setAttributes( { scrollField: newValue } );
    }

    function onChangeClassField( newValue ) {
      setAttributes( { classField: newValue } );
    }

    function onChangeLcode( newValue ) {
      if(newValue === '')
      { setAttributes( { url: '' } );
        setAttributes( { tempURL: defaultURL } );
      }
      else
      { setAttributes( { url: 'https://wubook.net/wbkd/wbk/' } );
      setAttributes( { tempURL: '' } );
      }
      setAttributes( { lcode: newValue } );
    }

    function onChangeDcode( newValue ) {
      setAttributes( { dcode: newValue } );
    }

    function onChangeLang( newValue ) {
      setAttributes( { lang: newValue } );
    }

    function onChangeSessionSeed( newValue ) {
      setAttributes( { sessionSeed: newValue } );
    }

    function onChangeOnlyRooms( newValue ) {
      setAttributes( { onlyRooms: newValue } );
    }

    function onChangeEurota( newValue ) {
      setAttributes( { eurota: newValue } );
    }

    function onChangeCurrency( newValue ) {
      setAttributes( { currency: newValue } );
    }

    function onChangeBookRooms( newValue ) {
      setAttributes( { bookRooms: newValue } );
    }

    function onChangePid( newValue ) {
      setAttributes( { pid: newValue } );
    }

    function onChangeOccupancies( newValue ) {
      setAttributes( { occupancies: newValue } );
    }

    function onChangeFilters( newValue ) {
      setAttributes( { filters: newValue } );
    }

    function onChangeRelink( newValue ) {
      setAttributes( { relink: newValue } );
    }

    function onChangeBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, background: newValue}}  );
    }

    function onChangeAddressBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, addressBackground: newValue }} );
    }

    function onChangeAddressText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, addressText: newValue }} );
    }

    function onChangeTopBar( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, topBar: newValue }} );
    }

    function onChangeTopBarText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, topBarText: newValue } });
    }

    function onChangeButtonBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, buttonBackground: newValue } });
    }

    function onChangeButtonText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, buttonText: newValue }} );
    }

    function onChangeAmenity( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, amenity: newValue }} );
    }

    function onChangePromoBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, promoBackground: newValue } });
    }

    function onChangePromoText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, promoText: newValue } });
    }

    function onChangeContinueButtonBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, continueButtonBackground: newValue } });
    }

    function onChangeContinueButtonText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, continueButtonText: newValue }} );
    }

    function onChangeRoomsText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, roomsText: newValue }} );
    }

    function onChangeVirtualsText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, virtualsText: newValue }} );
    }

    function onChangePricesText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, pricesText: newValue }} );
    }

    function onChangeOffersText( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, offersText: newValue }} );
    }

    function onChangeCalendarEndpointBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, calendarEndpointBackground: newValue } });
    }

    function onChangeCalendarBetweenBackground( newValue ) {
      setAttributes( {customColors: {...attributes.customColors, calendarBetweenBackground: newValue }} );
    }

    return (
      <iframe src={tempURL + url + "?ref=bed66&lcode=" + lcode + "&dcode=" + dcode + "&lang=" + lang 
                    + "&sessionSeed=" + sessionSeed + "&onlyrooms=" + onlyRooms + "&custom_colors=" + JSON.stringify(snakeCaseKeys(customColors))
                    + "&eurota=" + eurota + "&currency=" + currency + "&bookrooms=" + bookRooms + "&=pid" + pid
                    + "&occupancies=" + occupancies + "&filters=" + filters + "&relink=" + relink}  
          width={widthField} height={heightField} frameborder={borderField} scrollbars={scrollField} class={classField} id="bed66_iFrame">
        <InspectorControls>
        <PanelBody title="General iFrame Settings" initialOpen={ false }>
          <TextControl
            label="URL"
            value={url}
            placeholder="https://wubook.net/wbkd/wbk/"
            disabled="true"
            onChange={ onChangeURLField }
          />

          <TextControl
            label="iFrame Width"
            help="Default is 100%"
            value={ widthField }
            onChange={ onChangeWidthField }
          />

          <TextControl
            label="iFrame Height"
            help="Default is 500px"
            value={ heightField }
            onChange={ onChangeHeightField }
          />

          <TextControl
            label="Frame Border"
            help="Default is 0"
            value={ borderField }
            onChange={ onChangeBorderField }
          />

          <RadioControl
            label="Show Scroll Bars"
            selected={ scrollField }
            options={
              [
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' },
              ]}
            onChange={ onChangeScrollField }
          />

          <TextControl
            label="CSS Classes for iFrame"
            value={ classField }
            onChange={ onChangeClassField }
          />

          </PanelBody>
          <PanelBody title="Wubook Hotel Specific Settings"  initialOpen={ false }>
            <TextControl
              label="Lodging Code "
              help="Lodging Code (lcode) from Wubook"
              value={lcode}
              onChange={ onChangeLcode }
            />
            <TextControl
              label="Discount Code "
              help="Discount Code (dcode) from Wubook"
              value={dcode}
              onChange={ onChangeDcode }
            />
            <TextControl
              label="Language"
              value={lang}
              onChange={ onChangeLang }
            />
            <TextControl
              label="Session Seed"
              value={sessionSeed}
              onChange={ onChangeSessionSeed }
            />
            <TextControl
              label="Only Rooms"
              value={onlyRooms}
              onChange={ onChangeOnlyRooms }
            />
            <TextControl
              label="eurota"
              help="the eurota code to track the origin of the reservation."
              value={eurota}
              onChange={ onChangeEurota }
            />
            <TextControl
              label="Currency"
              help="the user’s currency (EUR, USD…)"
              value={currency}
              onChange={ onChangeCurrency }
            />
            <TextControl
              label="Book Rooms"
              value={bookRooms}
              onChange={ onChangeBookRooms }
            />
            <TextControl
              label="Package ID"
              value={pid}
              onChange={ onChangePid }
            />
            <TextControl
              label="Occupancies"
              help="the user’s currency (EUR, USD…)"
              value={occupancies}
              onChange={ onChangeOccupancies }
            />
            <TextControl
              label="Filters"
              value={filters}
              onChange={ onChangeFilters}
            />
            <TextControl
              label="Relink"
              help="a URL to redirect the user when the reservation process is over."
              value={relink}
              onChange={ onChangeRelink}
            />
          </PanelBody>
          <PanelBody title="Wubook Custom Color Settings"  initialOpen={ false }>
            <TextControl
              label="Background Color"
              help="Example: a1b2c3 "
              value={background}
              onChange={ onChangeBackground}
            />
            <TextControl
              label="Address Background Color"
              help="Example: a1b2c3 "
              value={addressBackground}
              onChange={ onChangeAddressBackground}
            />
            <TextControl
              label="Address Text Color"
              help="Example: a1b2c3 "
              value={addressText}
              onChange={ onChangeAddressText}
            />
            <TextControl
              label="Top Bar Color"
              help="Example: a1b2c3 "
              value={topBar}
              onChange={ onChangeTopBar}
            />
            <TextControl
              label="Top Bar Text Color"
              help="Example: a1b2c3 "
              value={topBarText}
              onChange={ onChangeTopBarText}
            />
            <TextControl
              label="Button Background Color"
              help="Example: a1b2c3 "
              value={buttonBackground}
              onChange={ onChangeButtonBackground}
            />
            <TextControl
              label="Button Text Color"
              help="Example: a1b2c3 "
              value={buttonText}
              onChange={ onChangeButtonText}
            />
            <TextControl
              label="Amenity Color"
              help="Example: a1b2c3 "
              value={amenity}
              onChange={ onChangeAmenity}
            />
            <TextControl
              label="Promo Background Color"
              help="Example: a1b2c3 "
              value={promoBackground}
              onChange={ onChangePromoBackground}
            />
            <TextControl
              label="Promo Text Background Color"
              help="Example: a1b2c3 "
              value={promoText}
              onChange={ onChangePromoText}
            />
            <TextControl
              label="Continue Button Background Color"
              help="Example: a1b2c3 "
              value={continueButtonBackground}
              onChange={ onChangeContinueButtonBackground}
            />
            <TextControl
              label="Continue Button Text Color"
              help="Example: a1b2c3 "
              value={continueButtonText}
              onChange={ onChangeContinueButtonText}
            />
            <TextControl
              label="Rooms Text Color"
              help="Example: a1b2c3 "
              value={roomsText}
              onChange={ onChangeRoomsText}
            />
            <TextControl
              label="Virtuals Text Color"
              help="Example: a1b2c3 "
              value={virtualsText}
              onChange={ onChangeVirtualsText}
            />
            <TextControl
              label="Prices Text Color"
              help="Example: a1b2c3 "
              value={pricesText}
              onChange={ onChangePricesText}
            />
            <TextControl
              label="Offers Text Color"
              help="Example: a1b2c3 "
              value={offersText}
              onChange={ onChangeOffersText}
            />
            <TextControl
              label="Calendar Endpoint Background Color"
              help="Example: a1b2c3 "
              value={calendarEndpointBackground}
              onChange={ onChangeCalendarEndpointBackground}
            />
            <TextControl
              label="Calendar Between Background Color"
              help="Example: a1b2c3 "
              value={calendarBetweenBackground}
              onChange={ onChangeCalendarBetweenBackground}
            />
          </PanelBody>
        </InspectorControls>
        </iframe>
    );
  }

  export default hot(module)(EditBlock);